import { render, staticRenderFns } from "./RoomLockedChatMessage.htm?vue&type=template&id=a8b4129c&scoped=true&"
import script from "./RoomLockedChatMessage.ts?vue&type=script&lang=js&"
export * from "./RoomLockedChatMessage.ts?vue&type=script&lang=js&"
import style0 from "./RoomLockedChatMessage.scss?vue&type=style&index=0&id=a8b4129c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b4129c",
  null
  
)

export default component.exports